export * from './homeActions';

export function loginUser(email, password, history) {
  return {
    type: 'LOGIN_USER',
    payload: {
      email,
      password,
      history,
    },
  };
}

export function googleLoginUser(token, history) {
  return {
    type: 'GOOGLE_LOGIN_USER',
    payload: {
      token,
      history,
    },
  };
}

export function setUserInfo(operatorDetails) {
  return {
    type: 'SET_USER_INFO',
    payload: {
      operatorDetails,
    },
  };
}

export function showError(errorTitle, errorDesc) {
  return {
    type: 'SHOW_ERROR',
    payload: {
      hasError: true,
      errorTitle,
      errorDesc,
    },
  };
}

export function hideError() {
  return {
    type: 'HIDE_ERROR',
    payload: {
      hasError: false,
      errorTitle: 'Something went wrong',
      errorDesc: 'Check your internet connection and try again',
    },
  };
}

export function setAuthToken(authToken) {
  return {
    type: 'AUTH_TOKEN',
    payload: authToken,
  };
}

export function setDoctorProfile({
  basicProfile,
  practiceCenters,
  slots,
  education,
  experience,
  awards,
  fulfilment,
  membership,
  registrations,
  services,
  specializations,
}) {
  return {
    type: 'SET_PROFILE',
    payload: {
      basicProfile,
      practiceCenters,
      slots,
      education,
      experience,
      awards,
      fulfilment,
      membership,
      registrations,
      services,
      specializations,
    },
  };
}

export function logoutUser(history) {
  return {
    type: 'LOGOUT_USER',
    payload: {
      history,
    },
  };
}

export function resetUserInfo() {
  return {
    type: 'RESET_USER_INFO',
  };
}

export function receiveDataFromOps(data) {
  return {
    type: 'RECEIVE_DATA_FROM_OPS',
    payload: data,
  };
}